import { render, staticRenderFns } from "./SvgLoader.vue?vue&type=template&id=2c3510ff"
import script from "./SvgLoader.vue?vue&type=script&lang=js"
export * from "./SvgLoader.vue?vue&type=script&lang=js"
import style0 from "./SvgLoader.vue?vue&type=style&index=0&id=2c3510ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports